export default "__VITE_ASSET__CEO0p5QD__"